sap.ui.require(["sap/ui/core/Core"]);
